export default "__VITE_PUBLIC_ASSET__df98c66e__"